import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';

export const uMPermissionsApi = createApi({
  reducerPath: 'uMPermissionsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: [ 'Permissions'],
  endpoints: (builder) => ({
    listPermissions: builder.query({
      query: (params) => ({
        url: `users/permissions/`,
        params,
      }),
      providesTags: ['Permissions'],
    }),
    createPermission: builder.mutation({
      query: (data) => ({
        url: `users/permissions/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Permissions'],
    }),
    updatePermission: builder.mutation({
      query: ({ id, data }) => ({
        url: `users/permissions/${id}/`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Permissions'],
    }),
  }),
});

export const {
  useListPermissionsQuery,
  useCreatePermissionMutation,
  useUpdatePermissionMutation,
} = uMPermissionsApi;
